module.exports = __webpack_public_path__ + "img/select-all.e63966f0.svg";